import Navigation from "../../components/Navigation/Navigation";
import style from './Main.module.scss'
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {HOME_ROUTE, MAIN_PAGE_ROUTE} from "../../routing/consts";
import Header from "../../components/Header/Header";
import Scrollbars from "react-custom-scrollbars-2";
import {signularisApi} from "../../store/api/signularisApi";
import {useAppDispatch} from "../../hooks/redux";

const Main = () => {
    const [hideMenu, setHideMenu] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (location.pathname === MAIN_PAGE_ROUTE) {
            navigate(HOME_ROUTE, {replace: true});
        }
        dispatch(signularisApi.util.invalidateTags(['documentCount']));
    }, [location.pathname, navigate, dispatch]);

    const toggleMenu = () => setHideMenu(prev => !prev);
    const openMenu = () => setHideMenu(false);

    return (
        <div className={`${style.app} ${hideMenu ? style.hideMenu : ''}`}>
            <div className={style.nav}>
                <Navigation hideMenu={hideMenu} openMenu={openMenu}/>
            </div>
            
            {/* Тень для мобильной версии */}
            <div onClick={toggleMenu} className={style.shadow}></div>

            <div className={style.content}>
                <Header hideMenu={hideMenu} toogleMenu={toggleMenu}/>
                
                <div className={style.scrollContainer}>
                    <Scrollbars
                        autoHide
                        autoHeight
                        autoHeightMin={'calc(100vh - 100px)'}
                        style={{width: '100%'}}
                    >
                        <main className={style.mainInner}>
                            <Outlet/>
                        </main>
                    </Scrollbars>
                </div>
            </div>
        </div>
    );
};

export default Main;
